import type { QuoteDocument, Auth0User } from 'paintscout'
import { uuid, getOwnerFromUser } from '../../../util'

/**
 * Creates a copy of the quote object
 *
 * @param quote
 */
export const copyQuote = (args: { quote: QuoteDocument; user: Auth0User }): QuoteDocument => {
  const { user } = args
  const {
    _id,
    _rev,
    number: _quoteNumber,
    sentReports: _sentReports,
    child_invoice: _child_invoice,
    child_invoice_number: _child_invoice_number,
    child_invoice_numbers: _child_invoice_numbers,
    deal_id: _deal_id,
    parent_quote,
    parent_quote_number,
    dates: _dates,
    followUps: _followUps,
    lastMessage: _lastMessage,
    ...quote
  } = args.quote
  const owner = getOwnerFromUser(user)
  const now = Date.now()

  return {
    ...quote,
    _id: uuid(),
    ...(quote.is_invoice && {
      parent_quote,
      parent_quote_number
    }),
    owner,
    assignedUsers: {
      [owner.id]: {
        assigned: true
      }
    },
    quote_date: now,
    dates: {
      created: now,
      updated: now,
      client: {},
      staff: {}
    },
    status: {
      value: 'draft'
    },
    urls: {},
    followUps: {},
    copyOf: _id,
    source: null,
    sources: quote.sources
      ? {
          ...quote?.sources,
          ...(quote?.sources?.['serviceTitan']
            ? {
                serviceTitan: {
                  ...quote?.sources?.['serviceTitan'],
                  estimateId: null
                }
              }
            : {})
        }
      : null,
    child_invoices: [],
    depositInfo: null,
    calculationLock: false,
    followUpsDisabled: false,
    contact: {
      ...quote.contact,
      wisetackLoanApplication: null
    }
  }
}
